import { Injectable, signal, inject } from '@angular/core';
import { SSOService } from '../../services/sso.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  isAuthenticated = signal(false);
  private ssoService = inject(SSOService);

  constructor() {
    // Subscribe to SSO authentication state
    this.ssoService.isAuthenticated$.subscribe(isAuth => {
      this.isAuthenticated.set(isAuth || this.hasTraditionalToken());
    });

    // Initialize authentication state
    this.checkAuthenticationState();
  }

  async logout() {
    // Logout from SSO if authenticated via SSO
    if (this.ssoService.isAuthenticated()) {
      await this.ssoService.logout();
    }

    // Clear traditional token
    localStorage.removeItem('token');
    this.isAuthenticated.set(false);
  }

  private hasTraditionalToken(): boolean {
    return !!localStorage.getItem('token');
  }

  private checkAuthenticationState(): void {
    const hasToken = this.hasTraditionalToken();
    const hasSSOAuth = this.ssoService.isAuthenticated();
    this.isAuthenticated.set(hasToken || hasSSOAuth);
  }

  getCurrentUser() {
    // Get current user data from SSO service (single source of truth)
    return this.ssoService.getCurrentUserData();
  }

  /**
   * Check if the current user has complete data from GetUserByEmail API
   */
  hasCompleteUserData(): boolean {
    return this.ssoService.hasCompleteUserData();
  }
}
